import Grid from "@mui/material/Grid";
import { compact, toUpper } from "lodash";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Switch, withRouter } from "react-router-dom";
import { CompatRoute } from "react-router-dom-v5-compat";
import appProperties from "../../appProperties";
import AppBar from "../../common/js/components/AppBar";
import Snackbar from "../../common/js/components/KMSnackbar";
import MaintenanceBanner from "../../common/js/components/MaintenanceBanner";
import NavDrawer from "../../common/js/components/NavDrawer";
import Notification from "../../common/js/components/Notification";
import "../../common/styles/components/Buttons.css";
import AdminContainer from "./admin/AdminContainer";
import CompaniesContainer from "./admin/CompaniesContainer";
import CompanyContainer from "./admin/CompanyContainer";
import TrainingVideos from "./admin/TrainingVideos";
import UserListingsContainer from "./admin/UserListingsContainer";
import AuditSearchContainer from "./audit/AuditSearchContainer";
import Authorization from "./auth/Authorization";
import authOperations from "./auth/ducks/operations";
import NotificationModal from "./auth/NotificationModal";
import CompContainer from "./comp/CompContainer";
import compOperations from "./comp/ducks/operations";
import Comps from "./comp/ReviewCompsContainer";
import ComplianceRuleContainer from "./compliance/ComplianceRuleContainer";
import AddContactContainer from "./crm/AddContactContainer";
import CrmContactsContainer from "./crm/CrmContactsContainer";
import DashboardContainer from "./dashboards/DashboardContainer";
import DealSummaryContainer from "./deal/DealSummaryContainer";
import DealsContainer from "./deals/DealsContainer";
import CreateDocumentTypeContainer from "./document-type/CreateDocumentTypeContainer";
import DocumentAdminLandingContainer from "./document-type/DocumentAdminLandingContainer";
import DocumentTypeAdminContainer from "./document-type/DocumentTypeAdminContainer";
import listingOperations from "./listing/ducks/operations";
import ListingRequestContainer from "./listing/ListingRequestContainer";
import ReviewListingsContainer from "./listing/ReviewListingsContainer";
import PropertyContainer from "./property/PropertyContainer";
import PropertyDetailContainer from "./property/PropertyDetailContainer";
import ReviewPropertiesContainer from "./property/ReviewPropertiesContainer";
import searchOperations from "./search/ducks/operations";
import ExternalRedirect from "./utils/ExternalRedirect";
import utils from "./utils/index";
import VoucherContainer from "./voucher/VoucherContainer";
import VouchersContainer from "./vouchers/VouchersContainer";

const User = Authorization(["ROLE_USER"]);
let AuthorizedVoucher;

if (appProperties.profile === "dev") {
    AuthorizedVoucher = VoucherContainer;
} else {
    AuthorizedVoucher = User(VoucherContainer);
}

const App = (props) => {
    const {
        authenticated,
        getUserProfile,
        location,
        redirectUrl,
        notification,
        snackbar,
        toggleSnackBar,
        toggleNotification,
    } = props;

    useEffect(() => {
        getUserProfile(compact(location.pathname.split("/")));
    }, []);

    const navDrawerWrapperStyles = {
        backgroundColor: "#233A47",
        maxHeight: "100vh",
        position: "sticky",
        top: 0,
        maxwidth: "220px",
        minWidth: "220px",
    };

    return (
        <div>
            {authenticated && (
                <div className="App">
                    <Grid container spacing={0} style={{ flexWrap: "nowrap" }} className="exogrid">
                        <Grid item style={navDrawerWrapperStyles}>
                            <NavDrawer {...props} />
                        </Grid>
                        <Grid item xs sx={{ flexGrow: 1, flexBasis: 0, maxWidth: "100%" }}>
                            <MaintenanceBanner showBanner={true} />
                            <AppBar {...props} />
                            <Grid>
                                <Grid item xs={6} sm={9} md={12}>
                                    <div
                                        className="appContainer"
                                        style={{ paddingLeft: 20, paddingRight: 20, paddingBottom: 20 }}
                                    >
                                        <Switch>
                                            <CompatRoute path="/vouchers" component={VouchersContainer} />
                                            <CompatRoute path="/voucher/:id" component={AuthorizedVoucher} />
                                            <CompatRoute path="/comp/:id" component={CompContainer} />
                                            <CompatRoute path="/comps" component={Comps} />
                                            <CompatRoute path="/deals" component={DealsContainer} />
                                            <CompatRoute path="/deal/:id" component={DealSummaryContainer} />
                                            <CompatRoute path="/properties" component={ReviewPropertiesContainer} />
                                            <CompatRoute path="/property/:id" component={PropertyContainer} />
                                            <CompatRoute path="/propdetail/:id" component={PropertyDetailContainer} />
                                            <CompatRoute
                                                path="/listing/:id"
                                                exact
                                                component={ListingRequestContainer}
                                            />
                                            <CompatRoute path="/listings" exact component={ReviewListingsContainer} />
                                            <CompatRoute
                                                path="/listings/review"
                                                exact
                                                component={ReviewListingsContainer}
                                            />
                                            <CompatRoute path="/dashboard" exact component={DashboardContainer} />
                                            <CompatRoute path="/admin/user/:id" exact component={AdminContainer} />
                                            <CompatRoute path="/admin/users" exact component={UserListingsContainer} />
                                            <CompatRoute path="/admin/companies" exact component={CompaniesContainer} />
                                            <CompatRoute path="/company/:id" exact component={CompanyContainer} />
                                            <CompatRoute path="/company" exact component={CompanyContainer} />
                                            <CompatRoute path="/contacts/:id" exact component={AddContactContainer} />
                                            <CompatRoute
                                                path="/contacts/create"
                                                exact
                                                component={AddContactContainer}
                                            />
                                            <CompatRoute path="/contacts" exact component={CrmContactsContainer} />
                                            <CompatRoute path="/training-content" exact component={TrainingVideos} />
                                            <CompatRoute
                                                path="/document-type"
                                                exact
                                                component={DocumentAdminLandingContainer}
                                            />
                                            <CompatRoute
                                                path="/document-type/document/:id"
                                                component={DocumentTypeAdminContainer}
                                            />
                                            <CompatRoute
                                                path="/document-type/create"
                                                component={CreateDocumentTypeContainer}
                                            />
                                            <CompatRoute path="/audit/" component={AuditSearchContainer} />
                                            <CompatRoute path="/parent-type/:id" component={ComplianceRuleContainer} />
                                            {/* external links */}
                                            <CompatRoute path="/power-bi" />
                                        </Switch>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Snackbar
                        open={snackbar.open}
                        message={snackbar.message}
                        variant={snackbar.variant}
                        vertical="top"
                        horizontal="center"
                        autoHideDuration={3000}
                        onClose={(event, reason) => {
                            if (reason === "clickaway") {
                                return;
                            }
                            toggleSnackBar(false, snackbar.variant, snackbar.message);
                        }}
                    />
                    <Notification
                        open={notification.open}
                        message={notification.message}
                        autoHideDuration={2000}
                        onClose={(event, reason) => {
                            if (reason === "clickaway") {
                                return;
                            }
                            toggleNotification(false, notification.message);
                        }}
                    />
                </div>
            )}
            {redirectUrl && <ExternalRedirect redirectUrl={redirectUrl} />}
            <NotificationModal />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userProfile: state.authReducer.userProfile,
        authenticatedUserProfile: state.authReducer.authenticatedUserProfile,
        snackbar: state.utilsReducer.snackbar,
        notification: state.utilsReducer.notification,
        role: state.authReducer.userProfile.role,
        authenticated: state.authReducer.authenticated,
        redirectUrl: state.authReducer.redirectUrl,
        user: state.authReducer.userProfile.user,
        firstName: state.authReducer.userProfile.firstName,
        lastName: state.authReducer.userProfile.lastName,
        authState: state.authReducer,
        elementsSaving: state.utilsReducer.elementsSaving,
        onSearchPage: state.searchReducer.onSearchPage,
        onGroupPage: state.searchReducer.onGroupPage,
        compSearchCleared: state.searchReducer.COMPS.searchCleared,
        listingSearchCleared: state.searchReducer.LISTINGS.searchCleared,
        compSearchCriteria: state.searchReducer.COMPS.searchCriteria,
        propertySearchCriteria: state.searchReducer.PROPERTY.searchCriteria,
        listingSearchCriteria: state.searchReducer.LISTINGS.searchCriteria,
        listingSearchRun: state.searchReducer.LISTINGS.searchRun,
        compSearchRun: state.searchReducer.COMPS.searchRun,
        propSearchRun: state.searchReducer.PROPERTY.searchRun,
        listingCurrentGroup: state.searchReducer.LISTINGS.currentGroup,
        compCurrentGroup: state.searchReducer.COMPS.currentGroup,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        toggleSnackBar: (open, variant, message) => {
            dispatch(utils.operations.snackbar(open, variant, message));
        },
        toggleNotification: (open, message) => {
            dispatch(utils.actions.notification(open, message));
        },
        changeProfile: (value) => {
            dispatch(authOperations.changeProfile(value));
        },
        getUserProfile: async (currentPath) => {
            const { history } = ownProps;
            const mainPage = await dispatch(authOperations.getUserProfile(currentPath));
            history.push(mainPage);
        },
        changeUser: (value) => {
            dispatch(authOperations.changeUser(value));
        },
        switchUserProfile: async (userAccountKey) => {
            const { history } = ownProps;
            const mainPage = await dispatch(authOperations.switchUserProfile(userAccountKey));
            history.push(mainPage);
        },
        viewSavedSearches: (searchType, userAccountKey) => {
            dispatch(searchOperations.viewSavedSearches(searchType.toUpperCase(), userAccountKey));
        },
        handleSearchSubmit: (searchType) => {
            if (searchType === "COMPS") {
                dispatch(compOperations.searchComps());
            } else if (searchType === "LISTINGS") {
                dispatch(listingOperations.searchListings("all_km_listings"));
            } else if (searchType === "PROPERTY_MODAL") {
                dispatch(searchOperations.executeSearch("property_modal"));
            } else {
                dispatch(searchOperations.executeSearch("PROPERTY"));
            }
            dispatch(searchOperations.storeSearchRun(true, toUpper(searchType)));
        },
        updateSearchTerm: (value, searchType) => {
            dispatch(searchOperations.updateFilter("searchTerm", value, searchType));
        },
        updateFilter: (field, value) => {
            dispatch(searchOperations.updateFilter(field, value, "PROPERTY"));
        },
        getSavedGroupsForUser: (searchType, userAccountKey) => {
            dispatch(searchOperations.getSavedGroupsForUser(userAccountKey, searchType));
        },
        toggleNameSearchModal: (open) => {
            dispatch(searchOperations.toggleNameSearchModal(open));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
